import InventoryImage from './InventoryImage';
export default InventoryImage;